import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { LoadingOutlined, LockOutlined } from '@ant-design/icons';
import { Form, Input, Popover } from 'antd';
import { onlyDigits } from 'utils/validations';

const FormItem = Form.Item;

export type FormValues = {
  pin: string;
};

const StyledIcon = styled(LockOutlined)`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.theme.iconColor};
`;

const LoginInput = styled(Input)`
  height: 46px;
  border-radius: 2px;
  max-width: 235px;
  .ant-input {
    letter-spacing: 36px;
    font-size: 18px;
    background-color: inherit;
  }
  .ant-input:not(:first-child) {
    padding-left: 20px;
  }
`;

interface Props {
  email: string;
  checking?: boolean;
  onPinEnter: (values: { email: string; pin: string }) => void;
  error: boolean;
}

const PinForm: React.FC<Props> = ({ email, onPinEnter, checking, error }) => {
  const intl = useIntl();
  const [form] = Form.useForm<FormValues>();
  useEffect(() => {
    if (error) {
      form.resetFields();
    }
  }, [form, error]);
  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={({ pin }) => {
        if (pin.length === 4) {
          onPinEnter({ email, pin });
        }
      }}
    >
      <Popover
        content={intl.formatMessage({
          defaultMessage: 'PIN of the owner when logging into the POS',
        })}
        placement="bottom"
      >
        <FormItem
          name="pin"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                defaultMessage: 'No PIN entered. Please enter your PIN.',
              }),
            },
          ]}
        >
          <LoginInput
            autoFocus
            maxLength={4}
            size="large"
            prefix={<StyledIcon />}
            suffix={checking && <LoadingOutlined />}
            type="password"
            disabled={checking}
            onKeyDown={onlyDigits}
            ref={(inputElement) => inputElement && inputElement.focus()}
          />
        </FormItem>
      </Popover>
    </Form>
  );
};

export default PinForm;
